import {parsePhoneNumber} from 'awesome-phonenumber'

import CountryCodes from '../assets/json/countryCodes.json'

// TODO: handle non-german phone numbers.
const formatPhoneNumber = (phoneNumber = '', locale = 'DE'): string | undefined =>
  parsePhoneNumber(phoneNumber, {regionCode: locale}).number?.international

const COUNTRY_CODES = CountryCodes

export {COUNTRY_CODES}
export default formatPhoneNumber
